import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { KEY_TOKEN } from 'src/app/core/services/local-storage/local-storage.constant';
import { LocalStorageService } from 'src/app/core/services/local-storage/local-storage.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  constructor(
    private localStorageService: LocalStorageService,
    private router: Router
  ) {
    this.goToHomePage();
  }

  private goToHomePage(): void {
    const value = this.localStorageService.getItem({ key: KEY_TOKEN });

    if (!value) return;

    this.router.navigate(['/home'])
  }

}
